import React from "react";

import ButtonV2 from "../../Components/ButtonV2";

import ControlledCarousel from "./Caroussel";

const BannerCard = () => {
  return (
    <div id="banners-section">
      <ControlledCarousel/>

      <div className="upcoming-block">
        <p>Upcoming Fortune Auctions Details</p>

        {/* <button>View Details</button> */}

        <ButtonV2
          btnName='View Details'
          btnOnClick={() => {}}
          className="banner-btn"
        />
      </div>

      <div className="upcoming-block1">
        <p>Assets with Pending Offers</p>

        {/* <button>50</button> */}
        <ButtonV2
          btnName='50'
          btnOnClick={() => {}}
          className="banner-btn"
        />
      </div>
    </div>
  );
};

export default BannerCard;
